<div class="modal-header">
  <h4 class="modal-title">Parent / Guardian Contact</h4>
</div>
<form #contactForm="ngForm" (ngSubmit)="save(contactForm)">
  <div class="modal-body">
    <div class="row mb-3">
      <label for="date" class="required-field col-md-4">Date</label>
      <div class="col-md-8">
        <ng-container *ngIf="edit">
          <input id="date" #date="ngModel" required type="date" class="form-control" name="date"
                 [(ngModel)]="contact.date">
          <ng-container *ngIf="date.touched && date.errors">
            <span *ngIf="date.errors['required']" class="text-danger">You must provide a date for the contact</span>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!edit">
          {{ contact.date | date: 'shortDate' }}
        </ng-container>
      </div>
    </div>
    <div class="row mb-3">
      <label for="type" class="required-field col-4">Method</label>
      <div class="col-md-8">
        <ng-container *ngIf="!edit">
          {{ contact.type }}
        </ng-container>
        <ng-container *ngIf="edit">
          <input id="type" #type="ngModel" required class="form-control" name="type" type="text"
                 [(ngModel)]="editContact.type" [disabled]="!edit">
          <ng-container *ngIf="type.touched && type.errors">
            <span *ngIf="type.errors['required']" class="text-danger">You must provide a method for the contact</span>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="row mb-3">
      <label for="communicator" class="col-md-4 required-field">Communicator</label>
      <div class="col-md-8" *ngIf="!edit">{{ contact.staff_name }}{{ (contact.staff_id || '') | staffId | async }}</div>
      <div class="col-md-8 d-flex" *ngIf="edit">
        <span class="me-auto">{{ editContact.staff_id  | staffId | async }}</span>
        <button type="button" class="btn btn-outline-secondary" (click)="selectStaff()">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
      <ng-container *ngIf="edit && !editContact.staff_id && staffOpened">
        <div class="offset-md-4 col-md-8">
          <span class="text-danger">You must select a communicator.</span>
        </div>
      </ng-container>
    </div>
    <div class="row mb-3">
      <label for="assess_shared" class="col-4">Assessment Shared:</label>
      <div class="col-8" *ngIf="!edit">{{ contact.assess_shared }}</div>
      <div class="col-8" *ngIf="edit">
        <input id="assess_shared" name="assess_shared" type="text" class="form-control"
               [(ngModel)]="editContact.assess_shared">
      </div>
    </div>
    <div class="row mb-3">
      <label for="info_shared" class="col-4">Information Shared:</label>
      <div class="col-8" *ngIf="!edit">{{ contact.info_shared }}</div>
      <div class="col-8" *ngIf="edit">
        <input id="info_shared" name="info_shared" class="form-control" type="text"
               [(ngModel)]="editContact.info_shared">
      </div>
    </div>
    <div class="row mb-3">
      <label for="outcome" class="col-4 required-field">Outcome:</label>
      <div class="col-8" *ngIf="!edit">{{ contact.outcome }}</div>
      <div class="col-8" *ngIf="edit">
        <textarea required #outcome="ngModel" minlength="10" maxlength="2500" id="outcome" name="outcome"
                  class="form-control" rows="3" [(ngModel)]="editContact.outcome"></textarea>
        <div class="d-flex">
          <span class="ms-auto me-3 text-secondary">{{ editContact.outcome?.length || 0 }} / 2500</span>
        </div>
        <ng-container *ngIf="outcome.touched && outcome.errors">
          <span *ngIf="outcome.errors['required']"
                class="text-danger">You must provide an outcome for the contact</span>
          <span *ngIf="outcome.errors['maxlength']" class="text-danger">Outcome must be less than 2500 characters</span>
          <span *ngIf="outcome.errors['minlength']"
                class="text-danger">Outcome must be greater than 10 characters</span>
        </ng-container>
      </div>
    </div>
  </div>
</form>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" *ngIf="edit" [disabled]="contactForm.pristine || contactForm.invalid"
          (click)="save(contactForm)">
    <i class="fa fa-floppy-o" aria-hidden="true"></i>
    Save
  </button>
  <button type="button" class="btn btn-primary" *ngIf="!edit" (click)="markEditContact()">
    <i class="fa fa-pencil" aria-hidden="true"></i>
    Edit
  </button>
  <button type="button" class="btn btn-secondary float-end" (click)="closeWindow()">
    <i class="fa fa-times" aria-hidden="true"></i>
    Close
  </button>
</div>
